import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './app/providers/app-provider';
import { AppRoutes } from './app/routes';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
